<template>
    <router-link :to="{ name: this.page, params: this.pageData }">
        <slot></slot>
    </router-link>
</template>

<script>
    export default {
        props: [
            'page',
            'pageData'
        ]
    }
</script>